<div
  class="recurring-currency-input-wrapper"
  [class.form-error-border]="error"
  [class.disabled]="disabled"
  (click)="focusInput()">
  <input
    #inputEl
    class="recurring-currency-input"
    type="text"
    inputmode="decimal"
    autocomplete="off"
    [attr.id]="controlId"
    [maskito]="mask"
    [value]="value"
    [disabled]="disabled"
    [placeholder]="placeholder"
    (input)="handleInput($event)"
    (blur)="handleBlur()" />
  <span *ngIf="value" class="suffix" aria-hidden="true">{{ suffix }}</span>
</div>
